import { CompanyOptimizedSchema, CompanySchema } from '../types';
import axiosInstance from './client';

export async function fetchCompanies() {
    const response = await axiosInstance.get('/companies/optimized');
    const data = response.data;

    const parsed = CompanyOptimizedSchema.array().safeParse(data);

    if(!parsed.success) {
        const errorDetails = parsed.error.issues
            .map(issue => `${issue.path.join('.')}: ${issue.message}`)
            .join('; ');
        throw new Error(`Company data validation error: ${errorDetails}`);
    }

    return parsed.data;
}

export async function getCompanyById(id: string) {
    const response = await axiosInstance.get(`/companies/${id}`, {
        timeout: 5000
    });
    const data = response.data;

    const parsed = CompanySchema.safeParse(data);

    if(!parsed.success) {
        const errorDetails = parsed.error.issues
            .map(issue => `${issue.path.join('.')}: ${issue.message}`)
            .join('; ');
        throw new Error(`Company (${id}) data validation error: ${errorDetails}`);
    }

    return parsed.data;
}